import { VpButton, VpDrawerFooter } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

interface FavoriteViewFormFooterProps {
  onCancel: () => void
  isSaveDisabled: boolean
  saveLabel: string
  saveTestId: string
  cancelTestId?: string
}

export function FavoriteViewFormFooter({
  onCancel,
  isSaveDisabled,
  saveLabel,
  saveTestId,
  cancelTestId,
}: Readonly<FavoriteViewFormFooterProps>) {
  const { t } = useTranslation()

  return (
    <VpDrawerFooter className="favorite-view-panel__footer">
      <VpButton
        type="button"
        variant="secondary"
        onClick={onCancel}
        data-testid={cancelTestId}
      >
        {t('cancel')}
      </VpButton>
      <VpButton type="submit" disabled={isSaveDisabled} data-testid={saveTestId}>
        {saveLabel}
      </VpButton>
    </VpDrawerFooter>
  )
}
